var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00D395"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82062 12.1427C4.68081 12.06 4.56482 11.9425 4.48398 11.8016C4.40313 11.6607 4.3602 11.5013 4.35938 11.3389V9.50906C4.35938 9.29137 4.5405 9.11531 4.76212 9.11643C4.833 9.11643 4.90275 9.13499 4.96463 9.16987L9.18506 11.5779C9.432 11.7186 9.58444 11.9773 9.58444 12.2569V14.1525C9.58407 14.2152 9.57132 14.2771 9.54692 14.3348C9.52251 14.3925 9.48694 14.4449 9.44224 14.4888C9.39755 14.5327 9.34461 14.5673 9.28647 14.5907C9.22834 14.6141 9.16615 14.6257 9.1035 14.625C9.01445 14.625 8.92702 14.6011 8.85038 14.5558L4.82062 12.1427ZM11.1116 8.66868C11.3591 8.80931 11.5099 9.06862 11.511 9.34762V13.1951C11.511 13.3087 11.4491 13.4139 11.3473 13.4691L10.4237 13.9776C10.4118 13.9842 10.3991 13.9893 10.386 13.9927V11.8564C10.386 11.5796 10.2381 11.3231 9.9945 11.1814L6.28875 9.01124V6.59981C6.28875 6.38212 6.46988 6.20606 6.69206 6.20718C6.76286 6.20729 6.83242 6.2257 6.894 6.26062L11.1128 8.66868H11.1116ZM12.9594 5.82693C13.2069 5.96756 13.3594 6.22631 13.3594 6.50699V12.1264C13.3587 12.1835 13.3426 12.2393 13.3128 12.288C13.283 12.3367 13.2406 12.3765 13.1901 12.4031L12.3142 12.8661V8.95331C12.3142 8.67712 12.1657 8.42118 11.9244 8.27887L8.13544 6.05531V3.76874C8.13544 3.69899 8.15512 3.63093 8.18944 3.57074C8.2446 3.48028 8.33281 3.41483 8.43539 3.38827C8.53797 3.3617 8.64686 3.37611 8.739 3.42843L12.9594 5.82693Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.185220481bdc8772d0b10a380deaec62.svg";
export { ForwardRef as ReactComponent };